import React from "react";
import { useSaveDesignSetup } from "@/lib/api/apps/hooks";
import type { DesignApp } from "@/lib/api/apps/types";
import { costLimitRefusal } from "../app-format";
import { InlineFigure } from "../limit-field";

/** "of $3.000": the app's cost limit, edited where it stands. */
export function CostLimit({ app }: { app: DesignApp }) {
  const save = useSaveDesignSetup(app.app_id);
  return (
    <InlineFigure
      value={app.cost_limit_cents}
      label="cost limit"
      prefix="of"
      refuse={(cents) => costLimitRefusal(cents, app.spent_cents)}
      onSave={(cents) =>
        save.mutateAsync({
          app,
          change: { cost_limit_cents: cents ?? app.cost_limit_cents },
        })
      }
    />
  );
}
